import * as JsUtils from './JsUtils.js';

const COLUMNS = 'abcdefgh'.split('');

//------------------------------------------------------------------------------
// Chess Util Functions
//------------------------------------------------------------------------------

export function validMove(move) {
    // move should be a string
    if (typeof move !== 'string') return false;
    
    // move should be in the form of "e2-e4", "f6-d5"
    var tmp = move.split('-');
    if (tmp.length !== 2) return false;
    
    return (validSquare(tmp[0]) === true && validSquare(tmp[1]) === true);
}
    
export function validSquare(square) {
    if (typeof square !== 'string') return false;
    return (square.search(/^[a-x][0-9]{1,2}$/) !== -1);
}
    
export function validPieceCode(code) {
    if (typeof code !== 'string') return false;
    return (code.search(/^[bw][0-9ABCDEFGHIJKQRNBP]$/) !== -1);
}
    
    // TODO: this whole function could probably be replaced with a single regex
export function validFen(fen) {
    if (typeof fen !== 'string') return false;
    
    // cut off any move, castling, etc info from the end
    // we're only interested in position information
    fen = fen.replace(/ .+$/, '');
    
    // FEN should be 8 sections separated by slashes
    var chunks = fen.split('/');
    if (chunks.length !== 8) return false;
    
    // check the piece sections
    for (var i = 0; i < 8; i++) {
        if (chunks[i] === '' ||
            chunks[i].length > 8 ||
            chunks[i].search(/[^kqrbnpKQRNBP1-8]/) !== -1) {
        return false;
        }
    }
    
    return true;
}
    
export function validPositionObject(pos) {
    if (typeof pos !== 'object') return false;
    
    for (var i in pos) {
        if (pos.hasOwnProperty(i) !== true) continue;
    
        if (validSquare(i) !== true || validPieceCode(pos[i]) !== true) {
        return false;
        }
    }
    
    return true;
}
    
    // convert FEN piece code to bP, wK, etc
export function fenToPieceCode(piece) {
    // black piece
    if (piece.toLowerCase() === piece) {
        return 'b' + piece.toUpperCase();
    }
    
    // white piece
    return 'w' + piece.toUpperCase();
}
    
    // convert bP, wK, etc code to FEN structure
export function pieceCodeToFen(piece) {
    var tmp = piece.split('');
    
    // white piece
    if (tmp[0] === 'w') {
        return tmp[1].toUpperCase();
    }
    
    // black piece
    return tmp[1].toLowerCase();
}
    
    // convert FEN string to position object
    // returns false if the FEN string is invalid
export function fenToObj(fen) {
    if (validFen(fen) !== true) {
        return false;
    }
    
    // cut off any move, castling, etc info from the end
    // we're only interested in position information
    fen = fen.replace(/ .+$/, '');
    
    var rows = fen.split('/');
    var position = {};
    
    var currentRow = 8;
    for (var i = 0; i < 8; i++) {
        var row = rows[i].split('');
        var colIndex = 0;
    
        // loop through each character in the FEN section
        for (var j = 0; j < row.length; j++) {
        // number / empty squares
        if (row[j].search(/[1-8]/) !== -1) {
            var emptySquares = parseInt(row[j], 10);
            colIndex += emptySquares;
        }
        // piece
        else {
            var square = COLUMNS[colIndex] + currentRow;
            position[square] = fenToPieceCode(row[j]);
            colIndex++;
        }
        }
    
        currentRow--;
    }
    
    return position;
}
    
    // position object to FEN string
    // returns false if the obj is not a valid position object
export function objToFen(obj) {
    /*if (validPositionObject(obj) !== true) {
        console.log('NOT VALID');
        return false;
    } */
    
    var fen = '';
    
    var currentRow = 8;
    for (var i = 0; i < 8; i++) {
        for (var j = 0; j < 8; j++) {
        var square = COLUMNS[j] + currentRow;
    
        // piece exists
        if (
            obj.hasOwnProperty(square) === true
            && (obj[square][0] === 'w' || obj[square][0] === 'b')
        ) {
            fen += pieceCodeToFen(obj[square]);
        }
    
        // empty space
        else {
            fen += '1';
        }
        }
    
        if (i !== 7) {
        fen += '/';
        }
    
        currentRow--;
    }
    
    // squeeze the numbers together
    // haha, I love this solution...
    fen = fen.replace(/11111111/g, '8');
    fen = fen.replace(/1111111/g, '7');
    fen = fen.replace(/111111/g, '6');
    fen = fen.replace(/11111/g, '5');
    fen = fen.replace(/1111/g, '4');
    fen = fen.replace(/111/g, '3');
    fen = fen.replace(/11/g, '2');
    
    return fen;
}

export function validAnimationSpeed(speed) {
    if (speed === 'fast' || speed === 'slow') {
      return true;
    }
  
    if ((parseInt(speed, 10) + '') !== (speed + '')) {
      return false;
    }
  
    return (speed >= 0);
}

// calculates square size based on the width of the container
// got a little CSS black magic here, so let me explain:
// get the width of the container element (could be anything), reduce by 1 for
// fudge factor, and then keep reducing until we find an exact mod 8 for
// our square size
export function calculateSquareSize(containerWidth, rows = 8) {
    //var containerWidth = parseInt(containerEl.css('width'), 10);
    
    // defensive, prevent infinite loop
    if (! containerWidth || containerWidth <= 0) {
        return 0;
    }
    
    // pad one pixel
    var boardWidth = containerWidth - 1;
    
    while (boardWidth % rows !== 0 && boardWidth > 0) {
        boardWidth--;
    }
    
    return (boardWidth / rows);
}

// returns an array of closest squares from square
export function createRadius(square) {
    var squares = [];
    
    // calculate distance of all squares
    for (var i = 0; i < 8; i++) {
        for (var j = 0; j < 8; j++) {
        var s = COLUMNS[i] + (j + 1);
    
        // skip the square we're starting from
        if (square === s) continue;
    
        squares.push({
            square: s,
            distance: squareDistance(square, s)
        });
        }
    }
    
    // sort by distance
    squares.sort(function(a, b) {
        return a.distance - b.distance;
    });
    
    // just return the square code
    var squares2 = [];
    for (i = 0; i < squares.length; i++) {
        squares2.push(squares[i].square);
    }
    
    return squares2;
}

// returns the distance between two squares
export function squareDistance(s1, s2) {
    s1 = s1.split('');
    var s1x = COLUMNS.indexOf(s1[0]) + 1;
    var s1y = parseInt(s1[1], 10);
    
    s2 = s2.split('');
    var s2x = COLUMNS.indexOf(s2[0]) + 1;
    var s2y = parseInt(s2[1], 10);
    
    var xDelta = Math.abs(s1x - s2x);
    var yDelta = Math.abs(s1y - s2y);
    
    if (xDelta >= yDelta) return xDelta;
    return yDelta;
}

// returns the square of the closest instance of piece
// returns false if no instance of piece is found in position
export function findClosestPiece(position, piece, square) {
    // create array of closest squares from square
    var closestSquares = createRadius(square);
    
    // search through the position in order of distance for the piece
    for (var i = 0; i < closestSquares.length; i++) {
        var s = closestSquares[i];
    
        if (position.hasOwnProperty(s) === true && position[s] === piece) {
        return s;
        }
    }
    
    return false;
}

// calculate an array of animations that need to happen in order to get
// from pos1 to pos2
export function calculateAnimations(pos1, pos2) {
    // make copies of both
    pos1 = JsUtils.deepCopy(pos1);
    pos2 = JsUtils.deepCopy(pos2);
    
    var animations = [];
    var squaresMovedTo = {};
    
    // remove pieces that are the same in both positions
    for (var i in pos2) {
        if (pos2.hasOwnProperty(i) !== true) continue;
    
        if (pos1.hasOwnProperty(i) === true && pos1[i] === pos2[i]) {
        delete pos1[i];
        delete pos2[i];
        }
    }
    
    // find all the "move" animations
    for (i in pos2) {
        if (pos2.hasOwnProperty(i) !== true) continue;
    
        var closestPiece = findClosestPiece(pos1, pos2[i], i);
        if (closestPiece !== false) {
        animations.push({
            type: 'move',
            source: closestPiece,
            destination: i,
            piece: pos2[i]
        });
    
        delete pos1[closestPiece];
        delete pos2[i];
        squaresMovedTo[i] = true;
        }
    }
    
    // add pieces to pos2
    for (i in pos2) {
        if (pos2.hasOwnProperty(i) !== true) continue;
    
        animations.push({
        type: 'add',
        square: i,
        piece: pos2[i]
        })
    
        delete pos2[i];
    }
    
    // clear pieces from pos1
    for (i in pos1) {
        if (pos1.hasOwnProperty(i) !== true) continue;
    
        // do not clear a piece if it is on a square that is the result
        // of a "move", ie: a piece capture
        if (squaresMovedTo.hasOwnProperty(i) === true) continue;
    
        animations.push({
        type: 'clear',
        square: i,
        piece: pos1[i]
        });
    
        delete pos1[i];
    }
    
    return animations;
}

// given a position and a set of moves, return a new position
// with the moves executed
export function calculatePositionFromMoves(position, moves) {
    position = JsUtils.deepCopy(position);

    for (var i in moves) {
    if (moves.hasOwnProperty(i) !== true) continue;

    // skip the move if the position doesn't have a piece on the source square
    if (position.hasOwnProperty(i) !== true) continue;

    var piece = position[i];
    delete position[i];
    position[moves[i]] = piece;
    }

    return position;
}

export function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function parseSquare(square) {
    let squareLetter = square.substring(0, 1);
    let squareNumber = parseInt(square.substring(1), 10);
    return [squareLetter, squareNumber];
}


// WEBPACK FOOTER //
// ./src/ChessUtils.js